import XLSX from 'xlsx';

function parseObjectKey(key) {
  if (key.indexOf('上車地點') > -1) return 'onLocation';
  if (key.indexOf('下車地點') > -1) return 'offLocation';
  if (key.indexOf('乘客數') > -1) return 'seats';
  if (key.indexOf('司機編號') > -1) return 'callNumber';
  if (key.indexOf('派單方式') > -1) return 'deliveryMethod';
  if (key.indexOf('身分證號') > -1) return 'identityCode';
  if (key.indexOf('車牌號碼') > -1) return 'licenseNumber';
  if (key.indexOf('預定上車時間') > -1) return 'estimateGetOnTime';
  if (key.indexOf('姓名') > -1) return 'name';
  if (key.indexOf('免驗身分') > -1) return 'verification';
  if (key.indexOf('福利身分') > -1) return 'class';
  if (key.indexOf('區域') > -1) return 'areaType';
  if (key.indexOf('居住地址') > -1) return 'address';
  if (key.indexOf('聯絡人') > -1) return 'contactPerson';
  if (key.indexOf('住家電話') > -1) return 'telephoneNumber';
  if (key.indexOf('聯絡電話1') > -1) return 'mobilePhoneNumber1';
  if (key.indexOf('聯絡電話2') > -1) return 'mobilePhoneNumber2';
}

function CSVToArray(strData, strDelimiter) {
  // Check to see if the delimiter is defined. If not,
  // then default to comma.
  strDelimiter = strDelimiter || ',';

  // Create a regular expression to parse the CSV values.
  var objPattern = new RegExp(
    // Delimiters.
    '(\\' +
      strDelimiter +
      '|\\r?\\n|\\r|^)' +
      // Quoted fields.
      '(?:"([^"]*(?:""[^"]*)*)"|' +
      // Standard fields.
      '([^"\\' +
      strDelimiter +
      '\\r\\n]*))',
    'gi'
  );

  // Create an array to hold our data. Give the array
  // a default empty first row.
  var arrData = [[]];

  // Create an array to hold our individual pattern
  // matching groups.
  var arrMatches = null;

  // Keep looping over the regular expression matches
  // until we can no longer find a match.
  while ((arrMatches = objPattern.exec(strData))) {
    // Get the delimiter that was found.
    var strMatchedDelimiter = arrMatches[1];

    // Check to see if the given delimiter has a length
    // (is not the start of string) and if it matches
    // field delimiter. If id does not, then we know
    // that this delimiter is a row delimiter.
    if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
      // Since we have reached a new row of data,
      // add an empty row to our data array.
      arrData.push([]);
    }

    var strMatchedValue;

    // Now that we have our delimiter out of the way,
    // let's check to see which kind of value we
    // captured (quoted or unquoted).
    if (arrMatches[2]) {
      // We found a quoted value. When we capture
      // this value, unescape any double quotes.
      strMatchedValue = arrMatches[2].replace(new RegExp('""', 'g'), '"');
    } else {
      // We found a non-quoted value.
      strMatchedValue = arrMatches[3];
    }

    // Now that we have our value string, let's add
    // it to the data array.
    arrData[arrData.length - 1].push(strMatchedValue);
  }

  // 出來的資料 keys 跟 values 是分開的，所以要再重組一次
  // const isOrders = arrData.splice(0, 1)[0].some(item => item === 'callNumber');
  // console.log('isOrders', isO/rders);
  const keys = arrData.splice(0, 1)[0].map(key => parseObjectKey(key));
  let data = [];
  for (let j = 0; j < arrData.length; j++) {
    let item = {};
    for (let i = 0; i < keys.length; i++) {
      item[keys[i]] = arrData[j][i].trim();
    }
    data.push(item);
  }

  return data;
}

export default function parseSheet(file) {
  return new Promise((resolve, reject) => {
    // Create A File Reader HTML5
    const reader = new FileReader();
    // Ready The Event For When A File Gets Selected
    reader.onload = function (e) {
      const data = e.target.result;
      if (file.type === 'text/csv') {
        const arrayData = CSVToArray(data);
        resolve(arrayData);
      } else {
        const wb = XLSX.read(data, { type: 'binary' });
        // Loop Over Each Sheet
        wb.SheetNames.forEach(sheetName => {
          // console.log(wb.Sheets[sheetName]);
          const XlRowObject = XLSX.utils.sheet_to_row_object_array(
            wb.Sheets[sheetName],
            { raw: false }
          );
          const data = XlRowObject.map(item => {
            return Object.keys(item).reduce((accu, curr) => {
              accu[parseObjectKey(curr)] = item[curr].trim();
              return accu;
            }, {});
          });
          resolve(data);
          // const jsonObject = JSON.stringify(XlRowObject);
          // console.log('jsonObject', jsonObject);
        });
      }
      reject(reader.onerror);
    };
    // Tell JS To Start Reading The File.. You could delay this if desired
    if (file.type === 'text/csv') {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  });
}
